import { defineStore } from 'pinia';

export const useRequestStore = defineStore('request', {
  state: () => ({
    controller: null
  }),

  actions: {
    createController() {
      if (this.controller) {
        this.controller.abort();
      }
      this.controller = new AbortController();
      return this.controller;
    },

    abortRequest() {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
    }
  }
});


export function cancelAllRequest() {
    const store = useRequestStore();
    store.abortRequest(); // atau createController, sesuai kebutuhan
}